import { render } from "./ticketUser.vue?vue&type=template&id=1c47cba1&scoped=true"
import script from "./ticketUser.vue?vue&type=script&lang=js"
export * from "./ticketUser.vue?vue&type=script&lang=js"

import "./ticketUser.vue?vue&type=style&index=0&id=1c47cba1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c47cba1"]])

export default __exports__